import React from 'react'
import { useScrollReset } from '../scroll'

const Publications = () => {
  useScrollReset()
  return (
    <div css='margin: 20px; text-align: center'>
      Coming Soon
    </div>
  )
}

export default Publications